import { Dimension, Units } from "@freightsimple/ui-core/Data/Units";
import { DimensionInput } from "@freightsimple/ui-core/Controls/DimensionInput";
import type { ErrorMessageType } from "@freightsimple/ui-core/FormLayout/FormItem";
import { claimsFieldWidth } from "../Helpers/claimsFieldWidth";

interface ClaimsPiecesInputProps {
  dataTestId: string;
  label: string;
  value?: number | undefined;
  onChange: (value: number | undefined) => void;
  errorMessage: ErrorMessageType;
  forceValidation: boolean;
}

/**
 * A count-of-pieces field.
 *
 * Built on `DimensionInput` for the same reason `ClaimsCurrencyInput` is: it is
 * ui-core's only *optional* number input. A blank field emits `undefined`, so
 * validation can tell "not entered yet" from a real 0 — `NumberInput` types its
 * callback as `(value: number)` and can't express the difference. The
 * `Dimension`/`Units` pair only picks the unit suffix, and Length/Imperial is
 * the pair that renders none.
 */
export function ClaimsPiecesInput(props: ClaimsPiecesInputProps) {
  return (
    <DimensionInput
      dataTestId={props.dataTestId}
      label={props.label}
      value={props.value}
      onChange={props.onChange}
      units={Units.Imperial}
      dimension={Dimension.Length}
      errorMessage={props.errorMessage}
      forceValidation={props.forceValidation}
      widthPx={claimsFieldWidth.px}
    />
  );
}
